<template>
  <v-skeleton-loader
    :loading="skeleton"
    type="sentences"
    class="FormTemplatesFormCombobox"
  >
    <v-combobox
      ref="combobox"
      v-validate="validate"
      :value="value"
      :data-vv-as="`«${label}»`"
      :items="predefinedItems"
      :search-input.sync="search"
      hide-details="auto"
      :error-messages="$errors.first(name)"
      :return-object="false"
      :label="labelComputed"
      :name="name"
      multiple
      small-chips
      outlined
      dense
      class="FormTemplatesFormCombobox"
      @change="onChange"
    >
      <!--  -->

      <template #no-data>
        <v-list-item>
          <template v-if="!search">
            Начните печатать
          </template>

          <template v-else>
            <v-chip label small>
              <span>{{ search }}</span>
            </v-chip>
            <v-spacer />

            <v-btn
              depressed
              dense
              @click.stop="onAdd"
              v-text="'Добавить'"
            />
          </template>
        </v-list-item>
      </template>

      <template #selection="{ item, index }">
        <v-chip label small class="pr-2">
          <span>{{ item }}</span>

          <v-btn icon x-small @click.stop="onDelete(index)">
            <v-icon x-small v-text="'mdi-close'" />
          </v-btn>
        </v-chip>
      </template>

      <template #append>
        <v-badge
          :content="value.length"
          :dot="!value.length"
        >
          <BTooltipButton
            tile
            top
            icon="mdi-file-upload"
            tooltip="Загрузить списком"
            class-button="FormTemplatesFormCombobox__btn-load-list"
            @click="onLoadList"
          />
        </v-badge>
      </template>

      <!--  -->
    </v-combobox>
  </v-skeleton-loader>
</template>

<script>
import uniqueId from 'lodash/uniqueId'
import { createFormTemplatesFormEditor } from './utils'

import BTooltipButton from '@/components/common/BTooltipButton.vue'


export default {
  name: 'FormTemplatesFormCombobox',
  inject: ['$validator'],
  components: {
    BTooltipButton,
  },
  props: {
    skeleton: Boolean,
    value: {
      type: Array,
      required: true,
    },
    name: {
      type: String,
      default: () => uniqueId('form-templates-combobox-'),
    },
    label: {
      type: String,
      required: true,
    },
    validate: {
      type: [String, Object],
    },
    predefinedItems: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    search: '',
  }),
  computed: {
    labelComputed() {
      const required = JSON.stringify(this.validate || '').includes('required')
      return required ? `${this.label}*` : this.label
    },
  },
  methods: {
    async onLoadList() {
      const propsData = { list: [...this.value] }
      const modal = await createFormTemplatesFormEditor(this, propsData)
      const result = await modal.open()
      if (!result) return
      this.$emit('input', result.list)
    },
    onChange(list) {
      this.$emit('input', list)
      this.search = ''
      this.$refs.combobox.focus()
    },
    onAdd() {
      const list = this.value.concat(this.search)
      this.$emit('input', list)

      this.search = ''
      this.$refs.combobox.focus()
    },
    onDelete(index) {
      const list = this.value.slice()
      list.splice(index, 1)
      this.$emit('input', list)
    },
  },
}
</script>

<style lang="scss">
.FormTemplatesFormCombobox {
  &.v-select.v-input--dense .v-chip {
    margin: 4px;
  }

  &__btn-load-list {
    width: 32px !important;
    height: 32px !important;
    margin-top: -4px;
    margin-right: -8px;
    background-color: map-get($grey, lighten-2);
  }
}
</style>
